import React, { Component } from 'react'
import {Button, Form, InputNumber, Radio, Spin, message, Modal } from 'antd'
import {rechargeMoney, rechargeMoneyStatus} from '_src/api/api'

import './style.less'
class recharge extends Component {

  state = {
    amount: 100,
    payImg: 'https://pay.swiftpass.cn/pay/qrcode?uuid=https%3A%2F%2Fstatecheck.swiftpass.cn%2Fpay%2Fq%2FcRpMaqtfc',
    showQrcode: false,
    type: 'native_wechat',
  }

  componentWillUnmount () {
    clearTimeout(this.timer)
  }

  handleSubmit = (e) => {
    const self = this
    e.preventDefault()
    this.props.form.validateFields((err, values) => {
      if (!err) {
        self.setState({isLoading: true})
        values.amount = values.amount * 100
        rechargeMoney(values)
          .then(res => {
            let {content} = res.data.payment.payInfo
            let payImg = JSON.parse(content).code_img_url
            this.clock(res.data.id)
            self.setState({
              payImg,
              ...res.data,
              showQrcode: true,
              isLoading: false,
            })
          })
          .catch(error => {
            self.setState({ isLoading: false })
          })
      }
    })
  }

  clock = (id) => {
    rechargeMoneyStatus({id})
      .then(res => {
        if (res.data) {
          message.success('支付成功', 1.5, () => {
            this.props.history.push('/finance/merchants')
          })
        } else {
          this.timer = setTimeout(() => {
            this.clock(id)
          }, 2500)
        }
      })
  }

  paySuccess = () => {
    const {id} = this.state
    rechargeMoneyStatus({id})
      .then(res => {
        this.setState({showQrcode: false})
        // 支付成功去统计页面
        if (res.data) {
          message.success('支付成功', 2.5, () => {
            this.props.history.push('/finance/merchants')
          })
        } else {
          // 失败去商家充值记录页面
          message.warning('获取支付信息失败', 2.5, () => {
            this.props.history.push('/finance/rechargeLog')
          })
        }
      })
  }

  render () {
    const { getFieldDecorator } = this.props.form
    const {amount, payImg, payment, showQrcode} = this.state
    const payTitle = payment && payment.type === 'native_wechat' ? '微信支付' : '支付宝支付'
    return (
      <div className='recharge-page'>
        { this.state.isLoading ? <Spin tip=" 获取支付信息" className="loading" /> : ''}
        <Form className="modal-form" onSubmit={this.handleSubmit} >
          <Form.Item label="充值积分" labelCol={{ span: 8 }} wrapperCol={{ span: 8 }}>
            {getFieldDecorator('amount', {
              rules: [{ required: true, message: '请输入充值数量' }],
              initialValue: amount
            })(
              <InputNumber
                type='number'
                className='text-ipt'
                placeholder="请输入充值数量"
                min={100}
                step={100}
                onChange={text=>{ this.setState({amount: text}) }}
              />
            )}
          </Form.Item>
          <Form.Item label="应付金额" labelCol={{ span: 8 }} wrapperCol={{ span: 8 }}>
            <span className='money-span'>￥{amount}</span>
          </Form.Item>
          <Form.Item label="支付方式" labelCol={{ span: 8 }} wrapperCol={{ span: 8 }}>
            {getFieldDecorator('type', {
              rules: [{ required: true, message: '请选择支付方式' }],
            })(
              <Radio.Group>
                <Radio value="1">微信</Radio>
                <Radio value="2">支付宝</Radio>
              </Radio.Group>
            )}
          </Form.Item>
          <div className='btnBox'>
            <span className='btnLabel' />
            <Button type='primary' htmlType="submit" className='rechargebtn'>充值</Button>
          </div>
        </Form>

        <Modal
          title={payTitle}
          visible={showQrcode}
          okText="确认"
          cancelText="取消"
          footer={false}
          keyboard={false}
          maskClosable={false}
          closable={false}
        >
          <div className='payImgInner'>
            <div className='pay-tips'>请打开 “{payment && payment.type === 'native_wechat' ? '微信' : '支付宝'}” 扫描二维码支付</div>
            <div className='pay-tips'>
              <img src={payImg} alt="" />
              <img src={payment && payment.type === 'native_wechat' ? require('./../../../assets/wechat_pay.png') : require('./../../../assets/ali_pay.png') } className='payType' alt="" />
            </div>
            <div className='pay-tips'>
              <span className='pay-ing'>订单支付中</span> <Spin t1ip="Loading..." />
              <Button type='link' className='pay-success-btn' onClick={this.paySuccess}>支付完成</Button>
            </div>
          </div>
        </Modal>

      </div>
    )
  }
}
export default Form.create({ name: '' })(recharge)

